import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { InstallationCustomerContactPluginService } from './customer-contact.service';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../modal/confirm.component';
import * as _ from 'lodash';
import { maxPhoneLengthValidator } from '../../../utils/maxPhoneLength.directive';
import { EmailValidator } from '../../../utils';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'customer-contact-edit',
    templateUrl: './customer-contact-edit.component.html',
    standalone: false
})
export class InstallationCustomerContactEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  private contactToRemove: number;
  private sub = new Subscription();

  @ViewChild('customerContactDeleteConfirm', { static: true }) customerContactDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationCustomerContactPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['customerContacts'];
  }

  ngOnInit() {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService
      .updateCustomerContact(this.inspectionId, this.pointId, this.pluginId, model.customerContacts)
      .subscribe((res) => {
        this.processing = false;
        this.goToBack();
      });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['customerContacts'];
    control.push(this.initCustomer());
  }

  public openCustomerContactDeleteConfirm(i: number) {
    this.customerContactDeleteConfirm.open();
    this.contactToRemove = i;
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['customerContacts'];
    control.removeAt(this.contactToRemove);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      customerContacts: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['customerContacts'];
    _.forEach(this.plugin.config.CustomerContacts, (el) => {
      control.push(this.initCustomer(el));
    });
  }

  private initCustomer(el?: any) {
    return this.fb.group({
      FirstName: new UntypedFormControl(el && el.FirstName ? el.FirstName : ''),
      LastName: [el && el.LastName ? el.LastName : ''],
      Company: [el && el.Company ? el.Company : ''],
      JobFunction: [el && el.JobFunction ? el.JobFunction : ''],
      Email: [el && el.Email ? el.Email : '', Validators.compose([EmailValidator.validate])],
      Phone: [
        el && el.Phone ? el.Phone : '',
        [
          Validators.pattern(/^([+]?\d{1,2}[-| \s]?)?(\d{1,4}[-| ]?){1,4}?(\d{1,4}[-| ]?)\d{1,4}$/),
          Validators.minLength(10),
          maxPhoneLengthValidator(21)
        ]
      ]
    });
  }
}
